import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import api from "../../utils/api";
import {toast} from "react-toastify";

const WiseBerryAPIEnv = process.env.VITE_API_KEY;

export const getAllCustomNotes = createAsyncThunk(
  "employee/getAllCustomNotes",
  async ({id, page, sortId}, {rejectWithValue}) => {
    // debugger;
    // https://api.wiseberryonline.com.au/api/v1/note?contact=321529&created_by=2055475&type=8
    let res;
    try {
      if (sortId === null) {
        res = await api.get(`${WiseBerryAPIEnv}ho-note?&page=${page}`);
      } else {
        res = await api.get(
          `${WiseBerryAPIEnv}note?contact=${sortId}&created_by=${id}&type=8&page=${page}`
        );
      }

      return res.data;
    } catch (err) {
      // Error handling code
    }
  }
);

export const addCustomNotes = createAsyncThunk(
  "employee/addCustomNotes",
  async (data, {rejectWithValue}) => {
    // debugger;
    try {
      if (data?.ho_note === undefined) {
        const res = await api.post(`${WiseBerryAPIEnv}ho-note`, data, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        toast.success(res.data.message);
        return res.data.data;
      } else {
        const res = await api.post(`${WiseBerryAPIEnv}ho-note`, data, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        toast.success(res.data.message);
        return res.data.data;
      }
    } catch (err) {
      if (err.response && err.response.status === 401) {
        toast.error("Please Login, Authorization Denied");
      }
      return rejectWithValue(err.message);
    }
  }
);
export const deleteNotes = createAsyncThunk(
  "employee/deleteNote",
  async (id, {dispatch, rejectWithValue}) => {
    console.log("========id============================");
    console.log(id);
    console.log("=========id===========================");
    try {
      const res = await api.delete(
        `${WiseBerryAPIEnv}ho-note/${id.selected_ids[0]}`
      );
      // debugger;
      console.log("====================================");
      console.log(res.data.data);
      console.log("====================================");

      toast.success("Note(s) has been deleted successfully");
      return res.data;
    } catch (err) {
      if (err.response && err.response.status === 401) {
        toast.error("Please Login, Authorization Denied");
      }
      return rejectWithValue(err.message);
    }
  }
);

// bulkDeleteNote({
//   selected_ids: selectedRows.map((column) => column?.id),
// })
// https://api.wiseberryonline.com.au/api/v1/note/bulk-delete
// selected_ids
// :
// [19637454, 19637452, 19637451]
// export function bulkDeleteNote(prams) {
//   return axios.post(NOTE + "/bulk-delete", prams, {
//     headers: {
//       "Content-Type": "application/json",
//     },
//   });
// }

let initialState = {
  employeeNote: [],
  loading: false,
  employeeNoteError: null,
  addNote: {},
  deletedNotes: {},
  deletedNotesError: null,
  loadingDeletedNotes: false,
  addNoteError: null,
  loadingAddNote: false,
};

const getAllCustomNotesSlice = createSlice({
  name: "employeeNotes",
  initialState,
  reducers: {
    updateNoteInList: (state, action) => {
      const noteIndex = state.employeeNote.data.findIndex(
        (note) => note.id === action.payload.id
      );
      if (noteIndex !== -1) {
        const updatedNote = {
          ...action.payload,
          contact: state.employeeNote.data[noteIndex].contact,
        };
        state.employeeNote.data[noteIndex] = updatedNote;
      }
    },
    deleteNotesFromList: (state, action) => {
      console.log("====================================");
      console.log(action.payload);
      console.log("====================================");
      state.employeeNote.data = state.employeeNote.data.filter(
        (note) => !action.payload.selected_ids.includes(note.id)
      );
    },

    // Other reducers...
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllCustomNotes.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllCustomNotes.fulfilled, (state, action) => {
        console.log("==========action==========================");
        console.log(action.payload.data);
        console.log("=============action=======================");
        if (action.payload.data.current_page === 1) {
          // debugger;
          // This is the first page, replace the whole data
          state.employeeNote = action.payload.data;
        } else {
          // This is a subsequent page, append the new data to existing one
          state.employeeNote.data = [
            ...state.employeeNote.data,
            ...action.payload.data,
          ];
          state.employeeNote.current_page = action.payload.data.current_page;
        }
        state.loading = false;
        state.employeeNoteError = null;
      })

      .addCase(getAllCustomNotes.rejected, (state, action) => {
        state.loading = false;
        state.employeeNoteError = action.payload;
        state.employeeNote = [];
      })
      .addCase(addCustomNotes.pending, (state) => {
        state.loadingAddNote = true;
      })
      .addCase(addCustomNotes.fulfilled, (state, action) => {
        console.log("====================================");
        console.log(action.payload);
        console.log("====================================");
        state.addNote = action.payload;
        state.loadingAddNote = false;
        state.addNoteError = null;
      })
      .addCase(addCustomNotes.rejected, (state, action) => {
        state.loadingAddNote = false;
        state.addNoteError = action.payload;
        state.addNote = {};
      })
      .addCase(deleteNotes.pending, (state) => {
        state.loadingDeletedNotes = true;
      })
      .addCase(deleteNotes.fulfilled, (state, action) => {
        state.deletedNotes = action.payload.data;
        state.loadingDeletedNotes = false;
        state.deletedNotesError = null;
        // Remove the deleted note from employeeNote.data
        state.employeeNote.data = state.employeeNote.data.filter(
          (note) => note.id !== action.payload.data.id
        );
      })
      .addCase(deleteNotes.rejected, (state, action) => {
        state.loadingDeletedNotes = false;
        state.deletedNotesError = action.payload.data;
        state.deletedNotes = {};
      });

    // .addCase(logout.fulfilled, (state, action) => {
    //   // Update state with data from the rejected action
    //   return initialState;
    // });
  },
});

export const {updateNoteInList} = getAllCustomNotesSlice.actions;

export default getAllCustomNotesSlice.reducer;
